// src/components/modals/ConfirmPurchaseModal.jsx
import React from 'react';
import { Lock, X, Zap } from 'lucide-react';
import Mascot from '../Mascot';

export default function ConfirmPurchaseModal({ 
  item, 
  userProgress, 
  onConfirm, 
  onClose,
  currentSkin,
  onInsufficientXp  // ✅ Nueva prop para manejar error de XP
}) {
  if (!item) return null;

  const currentXp = userProgress.xp || 0;
  const canAfford = currentXp >= item.cost;

  // ✅ Manejar el click del botón
  const handleConfirm = () => {
    if (!canAfford) {
      // Si no tiene XP, llamar a la función de error
      const missingXp = item.cost - currentXp;
      onInsufficientXp?.({
        cost: item.cost,
        current: currentXp,
        missing: missingXp,
        itemName: item.title || item.name
      });
    } else {
      // Si tiene XP, proceder con la compra
      onConfirm(item);
    }
  };

  return (
    <div className="fixed inset-0 z-[300] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-8 text-center relative shadow-2xl animate-in zoom-in-95 border-4 border-indigo-100">
        
        {/* Mascota en la parte superior */}
        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-28 h-28 z-10">
          <Mascot type={currentSkin} />
        </div>

        <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-slate-100 rounded-full text-slate-400 hover:bg-slate-200 transition-colors">
          <X size={20} />
        </button>

        <div className="mt-8 space-y-4">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto text-amber-500 shadow-inner">
            <Lock size={32} />
          </div>

          <h2 className="text-2xl font-black text-slate-800">¿Desbloquear?</h2>
          
          <p className="text-slate-500 font-bold leading-tight">
            ¿Quieres obtener <br />
            <span className="text-indigo-600 font-black">"{item.title || item.name}"</span>?
          </p>

          <div className="bg-slate-50 p-4 rounded-2xl border border-slate-100">
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Costo de activación</p>
            <div className={`flex items-center justify-center gap-2 text-2xl font-black ${canAfford ? 'text-amber-500' : 'text-rose-500'}`}>
              <Zap fill="currentColor" /> {item.cost} XP
            </div>
            {/* ✅ Mostrar XP actual vs requerido */}
            {!canAfford && (
              <p className="text-xs font-bold text-slate-400 mt-2">
                Tienes {currentXp} XP · Necesitas {item.cost} XP
              </p>
            )}
          </div>

          <div className="grid gap-3 pt-2">
            {/* ✅ BOTÓN SIEMPRE ACTIVO */}
            <button
              onClick={handleConfirm}
              className={`w-full py-4 rounded-2xl font-black text-lg shadow-lg border-b-4 transition-all active:translate-y-1 active:border-b-0
                ${canAfford 
                  ? 'bg-green-500 text-white border-green-700 hover:bg-green-400' 
                  : 'bg-rose-500 text-white border-rose-700 hover:bg-rose-400'}`}
            >
              {canAfford ? '✅ CONFIRMAR COMPRA' : '⚠️ PROBAR SUERTE'}
            </button>
            
            <button 
              onClick={onClose}
              className="w-full py-2 text-slate-400 font-bold text-sm hover:text-slate-600 transition-colors"
            >
              CANCELAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
